import { faCopy } from '@fortawesome/pro-solid-svg-icons';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import React from 'react';

import { Button } from '../button';

export function ClipboardCopy({
  text,
  className,
  label,
  description,
  ...rest
}: {
  text: string;
  className?: string;
  description?: string;
  label?: string;
} & Omit<FontAwesomeIconProps, 'icon'>) {
  return (
    <Button
      className={cx('p-0', className)}
      transparent
      onClick={() => text && navigator.clipboard.writeText(text)}
      aria-label={label || 'Copy details'}
      aria-description={description || `Copy ${text}`}
    >
      <FontAwesomeIcon {...rest} icon={faCopy} size="1x" />
    </Button>
  );
}
